import { isMatchingRoute } from '$lib/services/routing/utils';
import type { ParamMatcher } from '@sveltejs/kit';

export const match: ParamMatcher = (value: string) => {
    return isMatchingRoute(value, '(content)/(hub)');
};
